import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8095";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" }
});

axiosInstance.interceptors.request.use(config => {
  const token = localStorage.getItem("authToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
}, error => Promise.reject(error));

axiosInstance.interceptors.response.use(response => {
  const newToken = response.headers["x-new-token"];
  if (newToken) localStorage.setItem("authToken", newToken);
  return response;
}, error => {
  if (error.response && error.response.status === 401) {
    localStorage.clear();
    window.location.href = "/Login";
  }
  return Promise.reject(error);
});

export default axiosInstance;
